import { Box, Loader } from "@wix/design-system";
import React, { Suspense } from "react";
const EmojiSelector = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_emojiInsertModal"  */
    "./emoji-selector.js"
  )
);
const EmojiSelectorLazy = ({ onEmojiAdd }) => /* @__PURE__ */ React.createElement(
  Suspense,
  {
    fallback: /* @__PURE__ */ React.createElement(Box, { height: 435, verticalAlign: "middle", align: "center" }, /* @__PURE__ */ React.createElement(Loader, { size: "small" }))
  },
  /* @__PURE__ */ React.createElement(EmojiSelector, { onEmojiAdd })
);
var emoji_selector_lazy_default = EmojiSelectorLazy;
export {
  emoji_selector_lazy_default as default
};
//# sourceMappingURL=emoji-selector-lazy.js.map
